import BookingsList from "./BookingsList";
import List from "@material-ui/icons/List";

const Bookings = {
    list: BookingsList,
    icon: List
};

export default Bookings;
